import * as React from 'react';
import { visuallyHidden } from './visually_hidden.css.js';

/**
 * Provides content for assistive technologies, such as screen readers, that is visually hidden.
 */
const VisuallyHidden = ({ children, as: Element = 'span', ...rest }) => {
    return (React.createElement(Element, { ...rest, className: visuallyHidden }, children));
};

export { VisuallyHidden };
